import { arrayHelpers, compareHelpers, errorHelpers } from '@approvalmax/utils';
import { selectors, useUserPreferences } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { useCallback, useMemo } from 'react';
import { amplitudeService } from 'services/amplitude';

import { getReportConfigsByCompanyId } from '../../selectors/reportConfigSelectors';
import { ReportConfigExpanded } from '../../types/ReportConfig';
import { ReportListSorting } from '../ReportsListToolbar/ReportsListToolbar.types';

export const useReportsListTiles = (company: selectors.types.ExpandedCompany) => {
    const reportsConfigs = useSelector((state) => getReportConfigsByCompanyId(state, company.id));

    const onReportClick = useCallback(() => {
        amplitudeService.sendData('reports: open report');
    }, []);

    const sortingFunction = useGetSortingFunction();

    const reports = useMemo(
        () => arrayHelpers.arraySort(reportsConfigs, sortingFunction),
        [reportsConfigs, sortingFunction]
    );

    return {
        reports,
        onReportClick,
    };
};

export const useGetSortingFunction = () => {
    const [activeSortingOptionId] = useUserPreferences('reports.Dashboard/ActiveSorting', ReportListSorting.ReportName);

    const nameComparator = compareHelpers.comparatorFor<ReportConfigExpanded>(
        compareHelpers.stringComparator2Asc,
        'name'
    );

    switch (activeSortingOptionId) {
        case ReportListSorting.ReportName:
            return nameComparator;

        case ReportListSorting.ExecutionDate:
            return compareHelpers.combineComparators(
                compareHelpers.comparatorFor<ReportConfigExpanded>(compareHelpers.dateComparator2Desc, 'lastRunDate'),
                nameComparator
            );

        case ReportListSorting.CreationDate:
            return compareHelpers.combineComparators(
                compareHelpers.comparatorFor<ReportConfigExpanded>(compareHelpers.dateComparator2Desc, 'createdDate'),
                nameComparator
            );

        default:
            throw errorHelpers.assertNever(activeSortingOptionId);
    }
};
